import React from "react"
import PropTypes from "prop-types"

import "./index.less"
import { Divider, Popover, Select } from "antd"
import { QuestionIcon } from "../../../../icons/svg/iconQuestion"
import { LockIcon } from "../../../../icons/svg/iconLock"
import { TYPE_QUESTION, TYPE_SURVEY } from "../../../../utils/constants"
import { filter, map } from "lodash"

export function SelectTypeQuestion(props) {
  const renderPopOverTypeQuestion = () => (
    <div className="PopoverTypeQuestion__Content" style={{ width: 376 }}>
      <div className="PopoverTypeQuestion__Content__Item">
        <strong className="PopoverTypeQuestion__Content__Item--title">
          Escala de Likert:
        </strong>
        <p className="PopoverTypeQuestion__Content__Item--description">
          El encuestado debe marcar, dentro de una escala numérica, qué tan de
          acuerdo se siente con una afirmación determinada.
        </p>
      </div>
      <Divider style={{ margin: 0 }} />
      <div className="PopoverTypeQuestion__Content__Item">
        <strong className="PopoverTypeQuestion__Content__Item--title">
          Opción múltiple:
        </strong>
        <p className="PopoverTypeQuestion__Content__Item--description">
          El encuestado debe elegir entre una serie de opciones como respuesta a
          la pregunta.
        </p>
      </div>
      <Divider style={{ margin: 0 }} />
      <div className="PopoverTypeQuestion__Content__Item">
        <strong className="PopoverTypeQuestion__Content__Item--title">
          Pregunta cualitativa:
        </strong>
        <p className="PopoverTypeQuestion__Content__Item--description">
          El encuestado introduce una respuesta abierta a la pregunta.
        </p>
      </div>
      <Divider style={{ margin: 0 }} />
      {props.surveyData.id_survey_type !== TYPE_SURVEY.climate.idSurveyType && (
        <>
          <div className="PopoverTypeQuestion__Content__Item">
            <strong className="PopoverTypeQuestion__Content__Item--title">
              NPS:
            </strong>
            <p className="PopoverTypeQuestion__Content__Item--description">
              Para la pregunta <strong>NPS</strong> (Net Promoter Score), el
              encuestado debe marcar, dentro de una escala numérica, que tanto
              recomendaría un producto, servicio u organización.
            </p>
          </div>
          <p className="PopoverTypeQuestion__Footer">
            El resultado se calculará de forma automática considerando el modelo
            NPS (detractores, pasivos y promotores).
          </p>
        </>
      )}
      {props.surveyData.id_survey_type === TYPE_SURVEY.climate.idSurveyType && (
        <>
          <div className="PopoverTypeQuestion__Content__Item">
            <strong className="PopoverTypeQuestion__Content__Item--title">
              NPS:
            </strong>
            <p className="PopoverTypeQuestion__Content__Item--description">
              Para la pregunta <strong>NPS</strong> (Net Promoter Score), el
              encuestado debe marcar, dentro de una escala numérica, que tanto
              recomendaría un producto, servicio u organización.
            </p>
          </div>
          <p className="PopoverTypeQuestion__Footer">
            El resultado se calculará de forma automática considerando el modelo
            NPS (detractores, pasivos y promotores).
          </p>
        </>
      )}
    </div>
  )

  const renderHeader = () => {
    const { isCreate } = props
    return (
      <div className="TypeQuestion__Header">
        <div className="TypeQuestion__Header--left">
          <span className="TypeQuestion__Header--title">Tipo de pregunta*</span>
          <Popover
            placement="bottomLeft"
            align={{ offset: [-10, 0] }}
            overlayClassName="PopoverTypeQuestion"
            title="Tipos de pregunta"
            content={renderPopOverTypeQuestion()}>
            <QuestionIcon />
          </Popover>
        </div>
        <div className="TypeQuestion__Header--right">
          {!isCreate && <LockIcon />}
        </div>
      </div>
    )
  }
  const filterQuestionsType = () => {
    const { questionTypes, engagementCheck } = props
    if (!Array.isArray(questionTypes)) return []

    if (engagementCheck) {
      return filter(questionTypes, (item) => item.id_question_type !== 2)
    }

    return questionTypes
  }

  const renderSelect = () => {
    const {
      idQuestionType,
      isCreate,
      surveyData,
      onChangeTypeQuestion,
      questionData,
    } = props
    return (
      <div className="TypeQuestion__Select">
        <Select
          value={idQuestionType}
          disabled={!isCreate}
          style={{ width: 280 }}
          onChange={(valueChange) => onChangeTypeQuestion(valueChange)}>
          {map(filterQuestionsType(), (item) => {
            const isDisable =
              questionData.id_question_type === TYPE_QUESTION.enps
                ? false
                : item.disable
            return (
              <Select.Option
                key={item.id_question_type}
                value={item.id_question_type}
                disabled={isDisable}>
                {item.name}
              </Select.Option>
            )
          })}
        </Select>
      </div>
    )
  }

  return (
    <div className="TypeQuestion">
      {renderHeader()}
      {renderSelect()}
    </div>
  )
}

SelectTypeQuestion.propTypes = {
  isCreate: PropTypes.bool,
  questionData: PropTypes.object,
  surveyData: PropTypes.object,
  idQuestionType: PropTypes.number,
  onChangeTypeQuestion: PropTypes.func,
  engagementCheck: PropTypes.bool,
  questionTypes: PropTypes.array,
}

export default SelectTypeQuestion
